import React from 'react';

import { PRIMER_NAME, OLIGO_SEQUENCE } from 'src/constants/forms';
import { Message } from 'src/core/components';
import {
  maxLenValidator,
  minLenValidator,
  nonEmptyValidator,
  startsWithSpaceValidator,
  primerNameSpecialCharValidator
} from 'src/validators';

import messages from './messages';

// const OLIGO_SEQUENCE_REGEX = '^[ACGTacgt]+$';
const OLIGO_SEQUENCE_REGEX = '^[a-zA-Z0-9\\[\\]]*$';
const MAX_PRIMER_NAME_CHARS = 60;
const MIN_PRIMER_NAME_CHARS = 1;
const MAX_OLGIOS_SEQUENCE_CHARS = 100;
const MIN_OLIGOS_SEQUENCE_CHARS = 5;

const messageValuesPrimer = {
  min: MIN_PRIMER_NAME_CHARS,
  max: MAX_PRIMER_NAME_CHARS,
};

const messageValuesOligos = {
  min: MIN_OLIGOS_SEQUENCE_CHARS,
  max: MAX_OLGIOS_SEQUENCE_CHARS,
};

export const oligoSequenceValidator = ({
  validator: (value) => new RegExp(OLIGO_SEQUENCE_REGEX).test(value) ? 'success' : 'error',
  errorMessage: <Message message={messages.oligosSequenceBasesError} />,
});

export const getFormValidators = () => ({
  [PRIMER_NAME]: [
    nonEmptyValidator(messages.primerNameRequiredError),
    minLenValidator(
      MIN_PRIMER_NAME_CHARS,
      { ...messages.primerNameLengthError, values: messageValuesPrimer }
    ),
    maxLenValidator(
      MAX_PRIMER_NAME_CHARS,
      { ...messages.primerNameLengthError, values: messageValuesPrimer }
    ),
    primerNameSpecialCharValidator(messages.primerNameSpecialCharError),
    startsWithSpaceValidator(messages.primerNameRequiredError)
  ],
  [OLIGO_SEQUENCE]: [
    nonEmptyValidator(messages.oligosSequenceRequiredError),
    oligoSequenceValidator,
    minLenValidator(
      MIN_OLIGOS_SEQUENCE_CHARS,
      { ...messages.oligosSequenceLengthError, values: messageValuesOligos }
    ),
    maxLenValidator(
      MAX_OLGIOS_SEQUENCE_CHARS,
      { ...messages.oligosSequenceLengthError, values: messageValuesOligos }
    )
  ],
});
